import { CustomElement } from "../../../../../slate";
import { EditorPlugin } from "../../slate/PowerEditorConfig";
import { createWithVoidInjector } from "../common";
import { ConfigurableTableBlockElement, ConfigurableTableBlockElementType } from "./ConfigurableTableBlockElement";

const withConfigurableTable = createWithVoidInjector(ConfigurableTableBlockElementType);

export const ConfigurableTableBlockPlugin: EditorPlugin = {
    key: "insert-configurable-table-block",
    commands: [{
        name: "insert-configurable-table-block",
        menu: { section: "insert-item", label: "Configurable table", label_id: "powerdoc.plugins.configurable_table_block.title" },
        invoke: editor => {
          editor.insertNode({
              type: ConfigurableTableBlockElementType,
              rows: [],
              children: [{ text: "", }],
          } as CustomElement);
        }
    }],
    customBlocks: { [ConfigurableTableBlockElementType]: ConfigurableTableBlockElement },
    inject: withConfigurableTable,
};
